import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { PageBreadcrumbTitle } from 'framework/components/breadcrumbs/PageBreadcrumbTitle';
import { IRepair } from 'gen/ApiClient';
import React from 'react';
import { PageReloadButtonX } from 'framework/components/layout/PageReloadButtonX';
import { RepairsPageBreadcrumbs } from '../RepairsPageBreadcrumbs';
import { RepairChips } from './RepairChips';
import { PageXHeaderActions } from 'framework/components/layout/PageXHeaderActions';

interface IProps {
	item: IRepair;
	reload: VoidFunction;
}

export const RepairDetailPageHeader = ({ item, reload }: IProps) => {
	return (
		<div
			className='df-row-ac fg1'
			style={{ paddingBottom: 16 }}>
			<RepairsPageBreadcrumbs />
			<PageBreadcrumbDivider />
			<PageBreadcrumbTitle title={item.reference} />
			<RepairChips
				item={item}
				style={{ marginLeft: 4 }}
			/>
			<div className='fg1'></div>
			<PageXHeaderActions>
				<PageReloadButtonX reload={reload} />
			</PageXHeaderActions>
		</div>
	);
};
